// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr:hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 10px;
}

tr th:hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 10px;
}

.shadow-box {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    margin-top: 10px;
}

#filter_input:focus {
    outline: none !important;
    border-color:rgba(0, 0, 0, 0.24);
    box-shadow: 0 0 10px #deedfa;
}

.pointer.active.desc:after {
    content: " ▼";
    color: #390263;
}
.pointer.active.asc:after {
    content: " ▲";
    color: #02661d   
}

.center {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.flex-row {
    display: flex;
    flex-direction: row;
}


:host ::ng-deep .ql-container {
    font-size: 15px;
}

:host ::ng-deep .contact-quill-view .ql-editor{
    font-size: 15px;
    min-height: 0px;
    padding: 2px;
    max-width: 400px;
    max-height: 160px;
    overflow: scroll;
}

tr.detail:hover {
  cursor: default;
}

tr.detail td {
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/app/contact/contact.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,wFAAwF;IACxF,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["tr:hover {\n    cursor: pointer;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 10px;\n}\n\ntr th:hover {\n    cursor: pointer;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 10px;\n}\n\n.shadow-box {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    padding: 10px;\n    margin: 10px;\n    border-radius: 10px;\n    margin-top: 10px;\n}\n\n#filter_input:focus {\n    outline: none !important;\n    border-color:rgba(0, 0, 0, 0.24);\n    box-shadow: 0 0 10px #deedfa;\n}\n\n.pointer.active.desc:after {\n    content: \" ▼\";\n    color: #390263;\n}\n.pointer.active.asc:after {\n    content: \" ▲\";\n    color: #02661d   \n}\n\n.center {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.flex-row {\n    display: flex;\n    flex-direction: row;\n}\n\n\n:host ::ng-deep .ql-container {\n    font-size: 15px;\n}\n\n:host ::ng-deep .contact-quill-view .ql-editor{\n    font-size: 15px;\n    min-height: 0px;\n    padding: 2px;\n    max-width: 400px;\n    max-height: 160px;\n    overflow: scroll;\n}\n\ntr.detail:hover {\n  cursor: default;\n}\n\ntr.detail td {\n  cursor: default;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
